import { render, staticRenderFns } from "./Page_PriceRequest.vue?vue&type=template&id=28bf0317&scoped=true&"
import script from "./Page_PriceRequest.vue?vue&type=script&lang=js&"
export * from "./Page_PriceRequest.vue?vue&type=script&lang=js&"
import style0 from "./Page_PriceRequest.vue?vue&type=style&index=0&id=28bf0317&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf0317",
  null
  
)

export default component.exports